(() => {
  const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
  const BODY_LOCK_CLASS_PATTERN = /\boverflow-hidden(?:-[\w-]+)?\b/;

  const shouldDisableLenis = () => {
    if (window.matchMedia(REDUCED_MOTION_QUERY).matches) return true;
    if (!document.body) return false;

    return BODY_LOCK_CLASS_PATTERN.test(document.body.className);
  };

  const initLenis = () => {
    if (typeof window.Lenis !== 'function') return;
    if (window.vermeilloLenis) return;

    const lenis = new window.Lenis({
      autoRaf: true,
      smoothWheel: true,
      smoothTouch: false,
    });

    const syncLenisState = () => {
      if (shouldDisableLenis()) {
        lenis.stop();
        return;
      }

      lenis.start();
    };

    const bodyObserver = new MutationObserver(syncLenisState);
    bodyObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });

    const reducedMotionMedia = window.matchMedia(REDUCED_MOTION_QUERY);
    const handleReducedMotionChange = () => syncLenisState();

    if (typeof reducedMotionMedia.addEventListener === 'function') {
      reducedMotionMedia.addEventListener('change', handleReducedMotionChange);
    } else if (typeof reducedMotionMedia.addListener === 'function') {
      reducedMotionMedia.addListener(handleReducedMotionChange);
    }

    document.addEventListener(
      'shopify:section:load',
      () => {
        lenis.resize();
        syncLenisState();
      },
      { passive: true }
    );

    window.addEventListener(
      'resize',
      () => {
        lenis.resize();
      },
      { passive: true }
    );

    window.vermeilloLenis = lenis;
    syncLenisState();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLenis, { once: true });
    return;
  }

  initLenis();
})();
